/**
 * D11 — the price a board US pill hands the US ticket. Only a login KNOWN to
 * have no US account drops it (Game Detail then shows US read-only, with no
 * ticket to hint). `null` presence (not read yet, or the read failed) is not
 * "no US": dropping the price there opened the ticket on an earlier pick.
 */
export function usPillPrefill(presence: boolean | null, priceCents: number | undefined): number | undefined {
  return presence !== false ? priceCents : undefined;
}
